import Gateway from '@/utils/Gateway';

let cacheData;

function handleRes(data, resolve) {
    const tokenStatus = data && parseInt(data.token_status, 10);
    let hasError = false;
    let errMsg;

    // 企业应用凭证刷新状态 0-正常，1-异常
    if (tokenStatus === 1) {
        hasError = true;
        errMsg = '通讯录参数错误，通讯录不能正常同步，请尽快修复';
    }

    resolve({
        hasError,
        errMsg
    });
}

// 获取通信录参数接口
export default function getInnerAppAccessToken(corpId, config) {
    const { useCache } = config || {};
    return new Promise(resolve => {
        if (useCache && cacheData) {
            handleRes(cacheData, resolve);
        } else {
            Gateway.get('/v1/account/wework/GetInnerAppAccessToken', { corp_id: corpId }).then(data => {
                handleRes(data, resolve);
                cacheData = data;
            });
        }
    });
}
